if(!document.cookie.match('calif_se_user_id')) {
  // console.log('user idがなかったので生成しました。');
  const lifespan = 90;
  let nowdate = new Date();
  nowdate.setTime(nowdate.getTime() + lifespan*24*60*60*1000);
  const lifespan_date = nowdate.toGMTString();
  const cookievalue = `calif_se_user_id=cf_user_${nowdate.getTime()}; `;
  const expires = "expires=" + lifespan_date + "; ";
  const path = "path=/";
  const dt = new Date('1999-12-31T23:59:59Z');
  document.cookie = cookievalue + expires + path;
}

function getCookieArray(){
    const arr = new Array();
    if(document.cookie != ''){
        const tmp = document.cookie.split('; ');
        for(let i=0;i<tmp.length;i++){
            const data = tmp[i].split('=');
            arr[data[0]] = decodeURIComponent(data[1]);
        }
    }
    return arr;
}

const calif_se_arr = getCookieArray();
const calif_user_id = calif_se_arr['calif_se_user_id'];
// console.log(calif_user_id);